class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();
      this.recommend();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-notification-recommend'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  recommend() {
    // DEBUG
      console.log("NNNNNNN 0st.");
function formatMoney(amount) {
  return new Intl.NumberFormat('ja-JP', {
    style: 'currency',
    currency: 'JPY',
  }).format(amount / 100); // Shopifyでは金額がセンチ単位で返されるため、100で割る
}

    
// カート内の商品のIDを取得して関連商品を表示
  const recommendationsContainer = document.getElementById("recommendations");

  // カート内の最初の商品の関連商品を取得する
  fetch("/cart.js")
    .then(response => response.json())
    .then(cart => {
      const productId = cart.items.length > 0 ? cart.items[0].product_id : null;

      if (productId) {
        // Product Recommendations APIを呼び出す
   fetch(`/recommendations/products.json?product_id=${productId}&limit=4`)
  .then(response => {
    if (!response.ok) {
      console.error('Fetch failed:', response.status, response.statusText);
      throw new Error('Failed to fetch recommendations');
    }
    return response.json();
  })
  .then(data => {
    console.log('Recommendation data:', data); // データを確認
    if (data && data.products) {
      // 関連商品を表示
      data.products.forEach(product => {
        const productHTML = `
          <div class="cart-notification-product">
            <div class="cart-notification-product__image global-media-settings">
              <a href="${product.url}"><img src="${product.featured_image}" alt="${product.title}" width="70" height="70" /></a>
            </div>
            <div>
              <h3 class="cart-notification-product__name h4"><a href="${product.url}">${product.title}</a></h3>
              <p>${formatMoney(product.price)}</p>
            </div>
          </div>
        `;
        recommendationsContainer.innerHTML += productHTML;
      });
    } else {
      console.error('No products in recommendations');
    }
  })
  .catch(error => {
    console.error('Error:', error);
  });
      }
    });    
  }
}

customElements.define('cart-notification', CartNotification);
